import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { UrlPipe } from '../../pipes/url.pipe';
import { CopyButton } from '../copy-button/copy-button.component';

@Component({
  selector: 'procure-external-link',
  templateUrl: './external-link.component.html',
  styleUrl: './external-link.component.scss',
  imports: [MatTooltip, CopyButton, UrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalLink {
  readonly url = input<string | null | undefined>(null);

  protected readonly normalizedUrl = computed(() => this.normalize(this.url()));

  protected readonly hasUrl = computed(() => this.normalizedUrl() !== null);

  private normalize(value: string | null | undefined): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    const trimmed = value.trim();

    return trimmed.length > 0 ? trimmed : null;
  }
}
